import React, { Component } from "react";
import { Row, Col, Button, Table, Drawer, Avatar, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import "./EvaluationMember.css";
import EvaluationMemberAdd from "./EvaluationMemberAdd";
import PlusIcon from "../../../svg/svgicon/PlusIcon";
import ButtonLinkIcon from "../../../Components/MyComponent/ButtonLinkIcon";
import { API } from "../../../API/API";
import { baseConfig } from "../../../Config/Config";
class EvaluationMember extends Component {
  state = {
    data: [],
    showNewInputForm: false,
    selectedMemberId: 0,
    invitationid: this.props.invitationid,
    tendername: this.props.tendername,
    isEdit: this.props.isEdit,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    const param = {
      url: baseConfig.makurl,
      session_id: localStorage.getItem("access_token"),
      invitationid: this.state.invitationid
    };
    API.post("/getMembers", param).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        this.setState({
          data: response.data.retData,
        });
      }
    });
  };
  showNewInputFormHandler = (show, memberid) => {
    this.setState({
      showNewInputForm: show,
      selectedMemberId: memberid,
    });
    if (show === false) {
      this.getData();
    }
  };
  handleDelete = (id) => {
    API.get("deleteMember?id=" + id).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        const dataSource = [...this.state.data];
        this.setState({
          data: dataSource.filter((item) => item.evaluationid !== id),
        });
      }
    });
  };
  render() {
    const columns = [
      {
        title: "Гишүүд",
        dataIndex: "members",
        key: "members",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <div>
              <Row justify="start" align="middle">
                <Col>
                  <Avatar
                    size={50}
                    src={
                      record?.img
                        ? "data:image/png;base64," + record?.img
                        : "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                    }
                  />
                </Col>
                <Col>
                  <Row style={{ marginLeft: 10 }}>
                    <Col>
                      <div
                        className="fieldLabel"
                        style={{
                          position: "static",
                          height: 20,
                          left: 0,
                          top: "calc(50% - 20px/2 - 8px)",
                        }}
                      >
                        {record.empname}
                      </div>
                    </Col>
                  </Row>
                  <Row style={{ marginLeft: 10 }}>
                    <Col>
                      <div
                        className="SubLabel"
                        style={{
                          position: "static",
                          height: 20,
                          left: 0,
                          top: "ccalc(50% - 16px/2 + 10px)",
                        }}
                      >
                        {record.positionname}
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          );
        },
      },
      {
        title: "Чиг үүрэг",
        dataIndex: "role",
        key: "role",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <Button
              style={{ fontWeight: "500", color: "#0358A7" }}
              type="link"
              disabled={this.state.isEdit ? false : true}
              onClick={() =>
                this.showNewInputFormHandler(true, record.evaluationid)
              }
            >
              {record.membertypename}
            </Button>
          );
        },
      },
      {
        title: " ",
        dataIndex: "operation",
        width: "1%",
        render: (_, record) =>
          this.state.data.length > 0 && this.state.isEdit ? (
            <Popconfirm
              title="Уcтгахдаа итгэлтэй байна уу?"
              onConfirm={() => this.handleDelete(record.evaluationid)}
            >
              <Button
                disabled={this.state.isEdit ? false : true}
                type="link"
                icon={<DeleteOutlined style={{ color: "red" }} />}
              />
            </Popconfirm>
          ) : null,
      },
    ];
    return (
      <div className="Container">
        <Row align="middle">
          <Col span={12}>
            <Row style={{ height: 56 }} justify="start" align="middle">
              <Col>
                <div className="HeaderLabel">1. Үнэлгээний хороо</div>
              </Col>
              <Col>
                <div className="divider"></div>
              </Col>
              {this.props.isEdit === false ? null :               
              <Col>
                <ButtonLinkIcon
                  onClick={() => this.showNewInputFormHandler(true, 0)}
                  icon={<PlusIcon />}
                  name="Гишүүн нэмэх"
                />
              </Col>}
            </Row>
          </Col>
        </Row>

        <div id="member-list">
          <Table
            dataSource={this.state.data}
            columns={[
              {
                title: "№",
                dataIndex: "key",
                key: "key",
                width: "3%",
                render: (text, row, index) => (
                  <>{this.state.data.indexOf(row) + 1}</>
                ),
              },
              ...columns,
            ]}
            pagination={false}
            rowKey="memberid"
            scroll={{ y: 340 }}
          />
        </div>
        <Drawer
          title="Гишүүн нэмэх"
          width="500px"
          placement="right"
          visible={this.state.showNewInputForm}
          onClose={() => this.showNewInputFormHandler(false, 0)}
          destroyOnClose={true}
          style
        >
          <EvaluationMemberAdd
            evaluationid={this.state.selectedMemberId}
            invitationid={this.state.invitationid}
            showForm={this.showNewInputFormHandler}
            tendername={this.state.tendername}
          ></EvaluationMemberAdd>
        </Drawer>
      </div>
    );
  }
}

export default withRouter(EvaluationMember);
